document.addEventListener('DOMContentLoaded', function () {
  // Select all top-level menu items
  const topMenuItems = document.querySelectorAll('.header__menu-item');

  topMenuItems.forEach(item => {
    item.addEventListener('click', function (event) {
      event.preventDefault(); // Prevent default link behavior

      // Extract the handle from the ID (remove 'HeaderMenu-')
      const fullId = item.id; // e.g., "HeaderMenu-bornetoj"
      const handle = fullId.replace('HeaderMenu-', ''); // Clean to "bornetoj"

      if (handle) {
        // Construct the correct URL
        const fullUrl = `/collections/${handle}`;
        console.log("Navigating to:", fullUrl);

        // Navigate to the constructed URL
        window.location.href = fullUrl;
      } else {
        console.log("No valid handle found for this menu item.");
      }
    });
  });
});

